import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser, Institucion } from '@/lib/api';

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  institucion: Institucion | null;  // active scoped institution (may differ from user.institucionId)
  loggedIn: boolean;
  setAuth: (token: string, user: AuthUser) => void;
  setInstitucion: (inst: Institucion) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      institucion: null,
      loggedIn: false,
      setAuth: (token, user) => set({ token, user, loggedIn: true }),
      setInstitucion: (inst) => set({ institucion: inst }),
      logout: () => set({ token: null, user: null, institucion: null, loggedIn: false }),
    }),
    { name: 'comunidata-auth', partialize: (s) => ({ token: s.token, user: s.user }) }
  )
);
